import React, { useState, useEffect } from 'react';
import { Plus, Check } from 'lucide-react';
import { useRefresh } from '../BlockCanvas';

const CreateProjectBlock = ({ user, onProjectCreated, size = 'medium', refreshTrigger }) => {
  const [success, setSuccess] = useState(false);
  const { openProjectCreationModal } = useRefresh();

  // Show success state when block is refreshed (indicating project creation)
  useEffect(() => {
    if (refreshTrigger) {
      setSuccess(true);
      // Reset success state after 2 seconds
      setTimeout(() => setSuccess(false), 2000);
    }
  }, [refreshTrigger]);

  const handleCreateProject = () => {
    openProjectCreationModal();
  };

  if (success) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center">
        <div className="p-3 bg-celadon-100 dark:bg-celadon-900/30 rounded-full mb-3">
          <Check className="h-6 w-6 text-celadon-600 dark:text-celadon-400" />
        </div>
        <p className="text-sm font-medium text-celadon-900 dark:text-celadon-100">Project created!</p>
        <p className="text-xs text-celadon-700 dark:text-celadon-300 mt-1">Your new project is ready to use</p>
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center ${size === 'small' ? 'h-9/10' : 'h-3/4'} text-center`}>
      <div className="p-3 bg-celadon-100 dark:bg-celadon-900/30 rounded-full mb-3">
        <Plus className="h-6 w-6 text-celadon-600 dark:text-celadon-400" />
      </div>
      <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">Create Project</h4>
      <p className="text-xs text-gray-600 dark:text-gray-400 mb-4">
        Start a new prompt collection
      </p>
      <button
        onClick={handleCreateProject}
        className="px-4 py-2 bg-celadon-600 text-white text-sm font-medium rounded-lg hover:bg-celadon-700 dark:bg-celadon-500 dark:hover:bg-celadon-600 transition-colors"
      >
        New Project
      </button>
    </div>
  );
};

export default CreateProjectBlock; 